/* unplugin-vue-components disabled */import script from "./TimeTableDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeTableDialog.vue?vue&type=script&setup=true&lang=js"

import "./TimeTableDialog.vue?vue&type=style&index=0&id=74e14f10&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e14f10"]])

export default __exports__